module.exports = __webpack_public_path__ + "static/media/21ECLAC51.e3419d64.jpg";